import axios from 'axios'
import baseService from './baseService'
import documentData from './data/document'

const serviceVideoService = {
  createDocumentRequest (documentRequestModel) {
    return new Promise((resolve, reject) => {
      if (baseService.isTestMode) {
        resolve('')
      } else {
        axios
          .post('/document/createDocumentRequest', documentRequestModel, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          }).catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  findAllByDealerIdFileLocation (dealerId, fileLocation) {
    return new Promise((resolve, reject) => {
      if (baseService.isTestMode) {
        resolve(documentData.all)
      } else {
        axios
          .get('/document/findAllByDealerIdFileLocation?dealerId=' + dealerId + '&fileLocation=' + fileLocation, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  }
}

export default serviceVideoService
